import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export interface IOrdemServicoFoto {
  idfoto: string;
  idos: string;
  arquivo: string;
  descricao?: string;
  criadoem?: string;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const tratarErro = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response) {
      return new Error(axiosError.response.data.errors?.default || 'Erro desconhecido');
    } else if (axiosError.request) {
      return new Error('Nenhuma resposta do servidor');
    } else {
      return new Error(axiosError.message);
    }
  }
  return new Error('Erro inesperado');
};

const create = async (idos: string, imagem: File, descricao?: string): Promise<IOrdemServicoFoto | Error> => {
  try {
    const formData = new FormData();
    formData.append('file', imagem);
    if (descricao) formData.append('descricao', descricao);
    const { data } = await Api.post(`/ordemservico/${idos}/fotos`, formData);
    return data;
  } catch (error) {
    return tratarErro(error);
  }
};

const deleteById = async (idos: string, idfoto: string): Promise<void | Error> => {
  try {
    await Api.delete(`/ordemservico/${idos}/fotos/${idfoto}`);
  } catch (error) {
    return tratarErro(error);
  }
};

export const OrdemServicoFotosService = {
  create,
  deleteById,
};
